import { StyleSheet } from 'react-native';
import { PROFILE_COLORS, PROFILE_LAYOUT } from './ProfileScreen.constants';

export const profileScreenStyles = StyleSheet.create({
  screen: {
    flex: 1,
    backgroundColor: PROFILE_COLORS.screenBg,
  },
  scroll: {
    flex: 1,
  },
  scrollContent: {
    width: '100%',
    maxWidth: PROFILE_LAYOUT.screenMaxWidth,
    alignSelf: 'center',
  },
  stateBlock: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    padding: 24,
    gap: 14,
  },
  stateText: {
    fontSize: 15,
    fontWeight: '600',
    color: PROFILE_COLORS.textMuted,
    textAlign: 'center',
  },
  retryBtn: {
    minHeight: 44,
    paddingHorizontal: 22,
    borderRadius: 10,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: PROFILE_COLORS.purple,
  },
  retryBtnPressed: { opacity: 0.85 },
  retryText: {
    fontSize: 15,
    fontWeight: '700',
    color: '#14093A',
  },
});
